// src/search/utils.ts
// Shared utility functions for search functionality

/**
 * Parse a comma-separated string or array into a string array.
 * Handles null, undefined, arrays, and comma-separated strings.
 */
export function parseCommaSeparated(
  value: string | string[] | null | undefined
): string[] {
  if (!value) return [];
  if (Array.isArray(value)) return value.filter(Boolean).map((v) => v.trim());
  return value
    .split(",")
    .map((v) => v.trim())
    .filter(Boolean);
}

import type { RecentSearchParams } from "./types";

/**
 * Parse search parameters from a RecentSearch entry into normalized values.
 */
export function parseSearchParams(params: RecentSearchParams): {
  street: string;
  postcodes: string[];
  statuses: string[];
} {
  const street = (params.thoroughfare || params.street || "").trim();
  const postcodes = parseCommaSeparated(params.postcode);
  const statuses = parseCommaSeparated(params.status);
  return { street, postcodes, statuses };
}
